import { nnbsp } from '../utils/chars';
import { pad0 } from '../../utils/number';
import { plural } from '../../utils/plural';
import { isAndroidApp } from '../../utils/version';
import { useAppSelector } from 'shared/hooks/redux/hooks';
import { AccountTariff } from 'console/billing/account-tariff/types';
export function format_price(price, options = {}) {
    return format_price_x100(~~(price * 100), options);
}
export function format_price_x100(price_x100, { with_rouble = true } = {}) {
    if (price_x100 == null || isNaN(price_x100) || !isFinite(price_x100))
        return null;
    const sign = price_x100 >= 0 ? '' : '–';
    const abs_x100 = Math.abs(price_x100);
    const frac = abs_x100 % 100;
    const int_part = Math.floor(abs_x100 / 100);
    let frac_str;
    if (frac === 0)
        frac_str = '';
    else if (frac % 10 === 0)
        frac_str = `.${frac / 10}`;
    else
        frac_str = `.${pad0(frac, 2)}`;
    let parts = [];
    let tmp = int_part;
    for (let i = 1; i <= 10; i++) {
        const group = tmp % 1000;
        tmp = Math.floor(tmp / 1000);
        parts.push(tmp !== 0 ? pad0(group, 3) : group.toString());
        if (tmp === 0)
            break;
    }
    const int_str = parts.reverse().join(nnbsp);
    parts = [sign, int_str, frac_str];
    if (with_rouble)
        parts.push(`${nnbsp}₽`);
    return parts.join('');
}
export function isAutoPaymentEnabled(state) {
    return state.billing.settings.data.auto_payment !== null;
}
export function is_paid_tariff(state) {
    return state.billing?.state?.data?.tariff?.current != AccountTariff.free;
}
export function format_day_price(days_left) {
    return days_left + nnbsp + plural(Math.abs(days_left), 'день', 'дня', 'дней');
}
export function get_account_balance_x100(state) {
    return state.billing?.state?.data?.balance_x100 ?? 0;
}
/**
 * @function
 * @return boolean
 * 04.2022 Google заблокировал выпуск приложение, т.к. не сделаны внутренние платежы
 * Решили скрыть упоминания о балансе, чтобы выпустить временную версию приложения
 * Если андроид:
 * показываем только тем у кого есть платный тариф или ненулевой баланс
 * Не андроид:
 * всё остаётся, как было
 */
export function useShowPaidOptionsWithBalance() {
    //сколько денег на балансе?
    const acc_balance = useAppSelector(get_account_balance_x100);
    //платный тариф включён?
    const paid_tariff_on = useAppSelector(is_paid_tariff);
    return isAndroidApp() ? paid_tariff_on || acc_balance > 0 : true;
}
/**
 * @function
 * @param state redux STATE
 * @param time_truncated просроченное время
 * @return boolean
 * 04.2022 Google заблокировал выпуск приложение, т.к. не сделаны внутренние платежы
 * Нужно ли показывать рекламу?
 * Если андроид:
 * НЕ ПОКАЗЫВАЕМ
 * Не андроид:
 * если платный тариф, то не надо
 * иначе если время просрочили
 */
export function selectNeedOpenAdvertisementPopup(state, time_truncated) {
    const paid_tariff = is_paid_tariff(state);
    return !paid_tariff && !isAndroidApp() && time_truncated;
}
